/* eslint-disable no-unused-vars */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface TargetState {
  notice: string;
  doneNotice: string;
  step: number;
  maxStep: number;
  season: number;
  previousPoint: number;
  targetPoint: number;
  title: string;
  setTarget: <K extends keyof TargetState>(key: K, value: TargetState[K]) => void;
  resetTarget: () => void;
}

const useTargetStore = create<TargetState>()(
  persist(
    (set) => ({
      notice: '',
      doneNotice: '',
      step: 0,
      maxStep: 0,
      season: 0,
      previousPoint: 0,
      targetPoint: 0,
      title: '',
      setTarget: (key, value) => set((state) => ({ ...state, [key]: value })),
      resetTarget: () =>
        set({
          notice: '',
          doneNotice: '',
          step: 0,
          maxStep: 0,
          season: 0,
          previousPoint: 0,
          targetPoint: 0,
          title: '',
        }),
    }),
    {
      name: 'target-storage', // localStorage에 저장될 Key 이름
      partialize: (state) => ({
        // 로컬 스토리지에 저장할 항목만 선택 가능
        notice: state.notice,
        doneNotice: state.doneNotice,
        step: state.step,
        maxStep: state.maxStep,
        season: state.season,
        previousPoint: state.previousPoint,
        targetPoint: state.targetPoint,
        title: state.title,
      }),
    },
  ),
);

export default useTargetStore;
